<template>
	<icon-button icon="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" :text="text" :action="action" :reverse="reverse" v-bind="$attrs"/>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			required: true
		},
		action: {
			type: Function,
			required: true
		},
		reverse: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/base/buttons/ArrowButton.vue